import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthServices, AlertServices, AppServices } from '@services';
import { ioValidators } from '@framework';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent {
    @Output() onPasswordReset = new EventEmitter(); //Added for Modal

    ResetPasswordForm: FormGroup;

    isLoading = false;
    HiddenOldPassword = true;
    HiddenNewPassword = true;

    constructor(
        @Inject('AuthServices') private _authServices: AuthServices,
        @Inject('AppServices') private _appServices: AppServices,
        @Inject('AlertServices') private _alertServices: AlertServices,
        private formBuilder: FormBuilder
    ) { }

    EnterKeyTrigger(_event: KeyboardEvent) {
        if (_event.keyCode === 13) {
            this.ProcessResetPassword();
            _event.stopPropagation();
            _event.preventDefault();
        }
    }

    ngOnInit() {

        this.isLoading = false;

        this.ResetPasswordForm = this.formBuilder.group({
            OldPassword: ['', [Validators.required]],
            NewPassword: ['', [Validators.required, ioValidators.hasPasswordComplexity]],
        });

    }

    ProcessResetPassword() {

        if (this.ResetPasswordForm.valid) {

            this.isLoading = true;

            let _Passwords = ({ 'OldPassword': this.ResetPasswordForm.get('OldPassword').value, 'NewPassword': this.ResetPasswordForm.get('NewPassword').value })
            this._authServices.ResetPassword(_Passwords).subscribe((_response) => {
                this.isLoading = false;
                this.onPasswordReset.emit();//Added for Modal
            }, (_error) => {
                this.isLoading = false;
            });

        }

    }

    goToLogin() {
        this._appServices.Logout()
    }

}
